"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A Wrapper components that centers content and add spacing on the sides
 */
var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      breakout = _ref.breakout,
      variant = _ref.variant,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "size", "breakout", "variant"]);

  return _react["default"].createElement(Wrap, _extends({
    breakout: breakout,
    className: className,
    size: size,
    variant: variant
  }, otherProps), children);
};

Wrapper.themeProps = {
  wrapper: {
    name: "WRAPPER",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var Wrap = _styledComponents["default"].div.withConfig({
  displayName: "Wrapper__Wrap",
  componentId: "psy997-0"
})(["width:100%;max-width:", ";margin:0 auto;padding-left:", ";padding-right:", ";& &{padding-left:0;padding-right:0;}", ";", ";"], function (p) {
  return p.size === "full" ? "none" : (0, _theming.wrapper)(p.size);
}, _theming.spacing.medium, _theming.spacing.medium, function (p) {
  return p.breakout && (0, _styledComponents.css)(["@media (max-width:", "){padding-left:0;padding-right:0;}"], _theming.wrapper.breakout);
}, (0, _theming.applyVariants)(Wrapper.themeProps.wrapper));

Wrapper.defaultProps = {
  className: "",
  size: "large",
  breakout: false
};
Wrapper.propTypes = {
  children: _themeContants.commonPropTypes.children,
  className: _propTypes["default"].string,
  size: _propTypes["default"].string,
  breakout: _propTypes["default"].bool
};
var _default = Wrapper;
exports["default"] = _default;